// src/store/authSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';

const initialState = {
    user: JSON.parse(localStorage.getItem('authUser')) || null,
    permissions: {},
    subscription: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        updateUser: (state, action) => {
            state.user = action.payload;
            localStorage.setItem('authUser', JSON.stringify(state.user));
        },
        loginSuccess: (state, action) => {
            const { user, tokens, permissions = {}, subscription = {} } = action.payload;
            state.user = user;
            localStorage.setItem('authUser', JSON.stringify(user));
            if (tokens?.access) localStorage.setItem('authToken', tokens.access);
            if (tokens?.refresh) localStorage.setItem('refreshToken', tokens.refresh);

            if (!isEmpty(permissions)) state.permissions = permissions;
            if (!isEmpty(subscription)) state.subscription = subscription;
        },
        logout: (state) => {
            state.user = null;
            state.permissions = {};
            state.subscription = null;
            localStorage.removeItem('authUser');
            localStorage.removeItem('authToken');
            localStorage.removeItem('refreshToken');
        },
    },
});

export const { loginSuccess, logout, updateUser } = authSlice.actions;
export default authSlice.reducer;
